module.exports = __webpack_public_path__ + "static/media/drone-logo.9ccf3515.svg";